module.exports = __webpack_public_path__ + "img/complaintTypes.23ef1486.svg";